import './App.css'
import React, {useEffect, useState} from 'react'
import {URL_API_USER_TRACK} from './utils/Constants'
import RequestSvc from './services/RequestSvc'
import SearchView from "./views/SearchView";
import UserVaultView from "./views/UserVaultView";
import HeaderComponent from "./components/toolbars/HeaderComponent";
import SidebarComponent from "./components/sidebars/SidebarComponent";
import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme({
    typography: {
        "fontFamily": `"Montserrat", "sans-serif"`,
    }
});

async function addTrack() {
    const queryParameters = new URLSearchParams(window.location.search)
    const src = queryParameters.get('src') ?? ''
    let url = URL_API_USER_TRACK + `?evento=Profilet&src=${src}`
    let requestSvc = new RequestSvc()
    let result = await requestSvc.get(url)
    if (result.status_code === 401) {
        window.location.href = 'https://clicspy.com/login';
    }
}

function App() {
    /**
     * Gets the referrer information and module name
     * @returns {string}
     */
    const getModuleName = () => {
        const url = window.location.href.toLowerCase();
        const referrer = document.referrer.toLowerCase();
        
        // Check for direct clicspy.com URLs first
        if (url.includes('clicspy.com/dashboard') || 
            url === 'http://clicspy.com' || 
            url === 'https://clicspy.com') {
            return 'dashboard';
        }
        
        // Check referrer if available
        if (referrer && referrer.includes('clicspy.com')) {
            const referrerPath = new URL(referrer).pathname;
            if (referrerPath === '/' || referrerPath === '/dashboard') {
                return 'dashboard';
            }
        }
        
        return url.substring(url.lastIndexOf('/') + 1);
    };

    // State to manage the selected offer subitem
    const [selectedOfferSubitem, setSelectedOfferSubitem] = useState(null);

    const moduleName = getModuleName();
    /**
     * Flag  que indica y almacena el estado del sidebar
     */
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    /**
     * Flag que indica si se esta mostrando la grilla de vault o no.
     */
    const [showVaultGrid, setShowVaultGrid] = useState(moduleName === 'dashboard');
    const [fk_categoryCode, setFk_categoryCode] = useState(null);
    const [filterName, setFilterName] = useState(null);
    const [newRow, setNewRow] = useState({});

    const setCategoryCodeSelected = (catCodeValue = null, filterNameValue = null) => {
        setFk_categoryCode(catCodeValue);
        setFilterName(filterNameValue)
    }


    useEffect(() => {
        addTrack()
    }, [])

    // Forzar barra lateral extendida cuando se selecciona un nicho/oferta
    useEffect(() => {
        if (selectedOfferSubitem) {
            setSidebarOpen(true);
        }
    }, [selectedOfferSubitem]);

    return (
        <ThemeProvider theme={theme}>
            <div>
                <HeaderComponent isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen}/>
                <div className={"flex-box-content"}>
                    <SidebarComponent isSidebarOpen={isSidebarOpen}
                                      setSidebarOpen={setSidebarOpen}
                                      showVaultGrid={showVaultGrid}
                                      setShowVaultGrid={setShowVaultGrid}
                                      selectedOfferSubitem={selectedOfferSubitem}
                                      setSelectedOfferSubitem={setSelectedOfferSubitem}                                      
                                      />
                    {/* Backdrop to close sidebar in overlay mode on small screens */}
                    <div
                        className="sidebar-backdrop"
                        onClick={() => setSidebarOpen(false)}
                        aria-hidden="true"
                    />
                    {
                        <div className="search-view-main-container">
                            <div style={{display: showVaultGrid ? 'block' : 'none'}}>
                                <UserVaultView isSidebarOpen={isSidebarOpen}
                                               setSidebarOpen={setSidebarOpen}
                                               fk_categoryCode={fk_categoryCode}
                                               filterName={filterName}
                                               setCategoryCodeSelected={setCategoryCodeSelected}
                                               newRow={newRow}
                                />
                            </div>
                            <div style={{display: !showVaultGrid ? 'block' : 'none'}}>
                                <SearchView
                                    isSidebarOpen={isSidebarOpen}
                                    setSidebarOpen={setSidebarOpen}
                                    setNewRow={setNewRow}
                                    selectedOfferSubitem={selectedOfferSubitem}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </ThemeProvider>
    )
}

export default App
